// @flow
import { camelCase, isEmpty } from 'lodash';

import { type NavItem } from 'Components/widgets/navigation/large/subnavs/NavigationLargeSubNavList';
import { COLORS } from 'Components/utils/color/colors';

import {
  getNavigationItemLinkTrackingData,
  getNavigationSubItemLinkTrackingData,
} from 'Components/widgets/navigation/Navigation.tracking';

function mapSubItemsProps(parentLabel, items) {
  if (isEmpty(items)) return [];

  return items.map(item => {
    const dataLabel = `${parentLabel}_${camelCase(item.label)}`;
    const subItemsProps: NavItem = {
      color: item.color || COLORS.GRAY_DARKER,
      hasImageBorder: item.frameForExclusiveCollection,
      label: item.label,
      link: {
        url: item.url,
        trackingData: getNavigationSubItemLinkTrackingData({
          label: dataLabel,
          parentLabel: parentLabel.split('_')[0],
        }),
      },
      seeMoreLabel: item.seeMoreLabel || '',
    };

    if (!isEmpty(item.imageUrl)) {
      subItemsProps.thumbnail = {
        imageUrl: item.imageUrl,
      };
    }

    if (!isEmpty(item.subItems)) {
      subItemsProps.subItems = mapSubItemsProps(dataLabel, item.subItems);
    }

    return subItemsProps;
  });
}

export const buildNavigationMenuItems = (
  menus: $ReadOnlyArray<CMSMenuItem> | null,
): Array<NavItem> => {
  if (!menus || !menus.length) {
    return [];
  }
  return menus.map(menu => {
    return {
      color: menu.color || COLORS.GRAY_DARKER,
      label: menu.label,
      link: {
        url: menu.url,
        trackingData: getNavigationItemLinkTrackingData(camelCase(menu.label)),
      },
      isList: menu.type === 'subItemsList',
      subItems: mapSubItemsProps(camelCase(menu.label), menu.items),
    };
  });
};
